import { Breadcrumb, Icon, DataTable, Button } from "pepsico-ds";
import { useState, useEffect, useRef, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import arReactivateService from "../../services/arReactivateService";
import "./audit-request.css";
import { useLoading } from "../../loader";
import NoDataFound from "../../common/no_data_found";
import axios from "axios";
import { useTranslation } from "react-i18next";
const OthersRequestList = () => {
    const { t,i18n } = useTranslation();
    const { REACT_APP_API_ENDPOINT } = process.env;
    const { showLoader, hideLoader } = useLoading();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [reactivatedData, setReactivatedData] = useState([]);
    const { state } = useLocation();
    const [selectedRow, setSelectedRow] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [rowData, setRowData] = useState(null);
    const navigate = useNavigate();

    const selectedGPID = useRef('');

    const columns = useMemo(() => [
        { columnKey: "gpid", header: t("auditRequest.gpid_upper_label"), initialSize: 220 , cellData: (ctx) => {
                return <>
                    <input
                        type="radio"
                        name="row-selection"
                        value={ctx.row.original.gpid}
                        checked={!!(selectedGPID.current && selectedGPID.current === ctx.row.original.gpid)}
                        onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
                        style={{ textAlign: 'center', marginRight: '10px' }}
                    />
                        {ctx.row.original.gpid}
                    </>
            }},
        { columnKey: "firstName", header: t("RequestNewAccessForOthers.first_name"), initialSize: 220, showColumnVisibility: true },
        { columnKey: "lastName", header: t("RequestNewAccessForOthers.last_name"), initialSize: 220 },
        { columnKey: "email", header: t("RequestNewAccessForOthers.email"), initialSize: 220 },
        { columnKey: "associate_type", header: t("RequestNewAccessForOthers.associate_type"), initialSize: 220 },
        { columnKey: "division", header: t("RequestNewAccessForOthers.division"), initialSize: 220 },
        { columnKey: "sub_division", header: t("RequestNewAccessForOthers.sub_division"), initialSize: 220 },
        { columnKey: "location", header: t("RequestNewAccessForOthers.location"), initialSize: 220 },
        { columnKey: "status", header: t("RequestNewAccessForOthers.status"), initialSize: 220 },
        { columnKey: "registered", header: t("RequestNewAccessForOthers.registered"), initialSize: 220 },
    ], [t, i18n.language, selectedRow]);

    useEffect(() => {
        fetchUserData();
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchUserData = async () => {
        setLoading(true);
        showLoader();
        setError(null);
        if (!state) {
            setError("Value is not found");
            return;
        }
        try {
            // const filterMapping = {
            //     "first_name": "firstName",
            //     "last_name": "lastName",
            //     "email": "emailAddress"
            // }
            // let key = filterMapping[state.type];
            // let userId = key ? { [key]: state.value } : {};
            // const response = await arReactivateService.getReactivatedUser(userId);

            const filterMapping = {
                [t('myIdmPortal.first_name')]: "firstName",
                [t('myIdmPortal.last_name')]: "lastName",
                [t('myIdmPortal.email')]: "email"
            }
            const response = await axios.post(REACT_APP_API_ENDPOINT + "user/searchuser", {
                [filterMapping[state.type]] : state.value
            })
            const allRows = Object.entries(response.data.userData).map(([gpid, user]) => ({
                gpid: gpid.trim(),
            }));
            setRowData(allRows);
            const transformedData = Object.entries(response.data.userData).map(([gpid, user]) => ({
                gpid: gpid.trim(),
                firstName: user.pepDisplayedFirstName?.trim() || "",
                lastName: user.pepDisplayedLastName?.trim() || "",
                email: user.mail || "",
                associate_type: user.pepUserType || "",
                division: user.pepDivisionName || "",
                sub_division: user.pepsubdivision || "",
                location: user.hrCountryName || user.pepLocName || "",
                status: user.pepUserStatus || "",
                registered: user.pepRegistered || "",
            }));
            setReactivatedData(transformedData);
            setSelectedRow(transformedData[0]);
            selectedGPID.current = transformedData[0]?.gpid
        } catch (err) {
            setError(err.message || "API call failed");
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    const renderDataTable = () => {
        return (
            <>
                <DataTable
                    className="datatable single-extension-table other-request-list"
                    key={i18n.language}  
                    columns={columns}
                    data={reactivatedData}
                    // isResizable={false}
                    enableSorting={true}
                    // manualPagination={true}
                    pageSize={10}
                    // totalRowsCount={50}
                    searchPlaceholder="Type a search keyword"
                    selection="single"
                    showColumnFilters={false}
                    showDescription={false}
                    // showFilterButton={false}
                    // showFilterToolbar={false}
                    // showMultiSortMenu={false}
                    // showPagination={true}
                    showSearchOption={false}
                    showTableHeader={false}
                    showTitle={false}
                    size="large"
                    pageIndex={0}
                    tableDescription=""
                    tableHeader=""
                />
            </>
        )
    }

    const renderErrorMesg = () => {
        return (
            <>
                <Icon
                    alt="alt value"
                    icon="mobiledata_off"
                    size="large"
                    style={{}}
                />
                <span className="error-title">No data to display</span>
                <span className="error-subtitle">Try a new search</span>
            </>
        )
    }
    const onRowSelectionChange = (e, user) => {
        e.stopPropagation();
        setSelectedRow(user);
        selectedGPID.current = user.gpid;
    };

    const onClickSubmit = () => {
        if (selectedRow && selectedRow.gpid) {
            const statePayload = { type: "gpid", value: selectedRow.gpid };
            navigate("/audit-requests", { state: statePayload });
        }
    }

    const onClickCancel = () => {
        navigate(-1);
    }


    const onClickMyIdm = () => {
        navigate("/myidmPortal");
    }

    // const reactivatedUserData = reactivatedData.map((user) => ({
    //     radio: (
    //         <input
    //             type="radio"
    //             name="row-selection"
    //             value={user.gpid}
    //             checked={!!(selectedRow && selectedRow.gpid === user.gpid)}
    //             onChange={(e) => onRowSelectionChange(e, user)}
    //             style={{ marginRight: '5px', textAlign: 'center' }}
    //         />
    //     ),
    //     ...user,
    // }));

    return (
        <main className="requests-container">
            <section className="requests-content pt-0">
                <header_ar className="header_ar-section">
                    {(!isMobile) ? (
                        <Breadcrumb
                            homeIcon={{
                                icon: "home",
                                onClick:()=>{
                                navigate("/home")
                                }
                            }}
                            breadcrumbs={[
                                {
                                    label: t("nonArExtension.home")
                                },
                                {
                                    label: <div onClick={()=>{
                                        navigate("/myidmPortal")
                                    }}>{t("nonArExtension.myidm")}</div>
                                },
                                {
                                    label: t("auditRequest.request_access_title")
                                }
                            ]}
                            className=""
                            style={{}}
                        />
                    ) : (
                        <div className="req-myidm-btn" onClick={() => onClickMyIdm()}><Icon
                            alt="alt value"
                            icon="arrow_back"
                            size="medium"
                            style={{ marginRight: '8px' }}
                        />{t("nonArExtension.myidm")}</div>
                    )}

                    <div className="header_ar-title mt-0">
                        <h1 className="mb-0">{t("auditRequest.view_requests_title")}</h1>
                    </div>
                </header_ar>
                <section className="main-section">
                    {!loading && !error && reactivatedData && reactivatedData.length > 0 ? (
                        <>
                            <div className="table-title-request">
                                {`${reactivatedData.length} results for ${state.type
                                    .split("_")
                                    .map((a) => a.charAt(0).toUpperCase() + a.slice(1))
                                    .join(" ")} ${state.value}`}
                            </div>

                            {renderDataTable()}

                            <div className="other-list-btn">
                                <Button
                                    size="medium"
                                    text={t("nonArExtension.cancel")}
                                    variant="secondary"
                                    onClick={() => onClickCancel()}
                                />
                                <Button
                                    size="medium"
                                    text={t("nonArExtension.submit")}
                                    variant="primary"
                                    onClick={() => onClickSubmit()}
                                />
                            </div>
                        </>

                    ) : (
                        !loading &&
                        !error && (
                            <div className="error-container">
                                {error ? <span className="search-subtitle">{error}</span> : <NoDataFound />}
                            </div>
                        )
                    )}
                    {error && (
                        <div className="error-container">
                            <NoDataFound />
                        </div>
                    )}
                    {/* {loading && (
                        <div className="loading-container">
                            <span className="search-subtitle">
                                Loading, this may take a moment...
                            </span>
                        </div>
                    )} */}
                </section>
            </section>
        </main>
    )
}
export default OthersRequestList;